import React, { createContext, useContext, useState, useMemo, ReactNode } from 'react';

interface FocusModeContextType {
  isFocusMode: boolean;
  setFocusMode: (value: boolean) => void;
  toggleFocusMode: () => void;
}

const FocusModeContext = createContext<FocusModeContextType | undefined>(undefined);

export const FocusModeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isFocusMode, setIsFocusMode] = useState(false);

  const setFocusMode = (value: boolean) => {
    setIsFocusMode(value);
  };

  const toggleFocusMode = () => {
    setIsFocusMode(prev => !prev);
  };

  const value = useMemo(
    () => ({ isFocusMode, setFocusMode, toggleFocusMode }),
    [isFocusMode]
  );

  return (
    <FocusModeContext.Provider value={value}>
      {children}
    </FocusModeContext.Provider>
  );
};

export const useFocusMode = () => {
  const context = useContext(FocusModeContext);
  if (context === undefined) {
    throw new Error('useFocusMode must be used within a FocusModeProvider');
  }
  return context;
};
